
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useProfileSubscription = (onProfilesChange: () => void) => {
  useEffect(() => {
    // Set up realtime subscription for profiles
    const profilesSubscription = supabase
      .channel('profiles-changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'profiles'
      }, () => {
        onProfilesChange();
      })
      .subscribe();
      
    return () => {
      supabase.removeChannel(profilesSubscription);
    };
  }, [onProfilesChange]);
};
